<template>
  <div id="areaEcharts">
    <div class="search-tab">
      <div class="date-select">
        <a-button
          :type="searchQuery.scope === 'WEEK' ? 'link' : 'text'"
          style="border: 1px solid #DCDCDC;"
          @click="dateClick('WEEK')"
        >{{ $t('pages_main_048') }}</a-button>
        <a-button
          :type="searchQuery.scope === 'MONTH' ? 'link' : 'text'"
          style="border: 1px solid #DCDCDC;"
          @click="dateClick('MONTH')"
        >{{ $t('pages_main_049') }}</a-button>
        <a-button
          :type="searchQuery.scope === 'YEAR' ? 'link' : 'text'"
          style="border: 1px solid #DCDCDC;"
          @click="dateClick('YEAR')"
        >{{ $t('pages_main_050') }}</a-button>
      </div>
    </div>
    <div class="charts-area">
      <div class="line-charts">
        <div v-show="!chartsLoading && !isLine" id="lineEmpty" class="flex-align" style="justify-content: center">
          <a-empty :image="simpleImage" />
        </div>
        <div class="charts-title">
          <img src="@/assets/icons/ic-listLogo.png">
          {{ $t('pages_main_043') }}
        </div>
        <div v-show="chartsLoading && !isLine" id="lineLoading" class="flex-align">
          <a-spin />
        </div>
        <div v-show="!chartsLoading && isLine" id="lineCharts" style="margin-top: 30px;" />
      </div>
      <!-- 扇形图 -->
      <div class="pie-charts">
        <div v-show="!chartsLoading && !isLine" id="pieEmpty" class="flex-align" style="justify-content: center">
          <a-empty :image="simpleImage" />
        </div>
        <div v-show="chartsLoading && !isPie" id="pieLoading" class="flex-align">
          <a-spin />
        </div>
        <div style="color: #333333;font-size: 20px;font-weight: 500;padding: 20px 20px 0 20px;">
          <img src="@/assets/icons/ic-transaction.png">
          {{ $t('pages_main_044') }}
        </div>
        <div v-show="!chartsLoading && isPie" id="pieCharts" style="height:280px" />
        <div v-show="chartsLoading && !isPie" style="height:280px" />
        <a-radio-group
          v-model:value="searchQuery.type"
          button-style="solid"
          style="margin-bottom: 20px;"
          @change="loadAmountRatio"
        >
          <a-radio-button value="AMOUNT">{{ $t('pages_main_046') }}</a-radio-button>
          <a-radio-button value="PENCOUNT">{{ $t('pages_main_047') }}</a-radio-button>
        </a-radio-group>
      </div>

    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, computed, nextTick } from 'vue'
import { _home } from '@/api'
import { Empty } from 'ant-design-vue'
import { parseMoney } from '@/util'
import i18n from '@/locale'
import * as echarts from 'echarts'
export default {
  name: 'AreaEcharts',
  setup() {
    const state = reactive({
      searchQuery: {
        startDate: '',
        endDate: '',
        scope: 'YEAR',
        type: 'AMOUNT'
      },
      chartsLoading: true,
      isLine: false,
      isPie: false
    })

    state.simpleImage = computed(() => {
      return Empty.PRESENTED_IMAGE_SIMPLE
    })

    onMounted(() => loadAmountRatio())

    const renderLineCharts = (dataX, dataY) => {
      const myChart = echarts.init(document.getElementById('lineCharts'))
      myChart.resize({
        height: 380
      })
      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataX
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '30%'],
          axisLabel: {
            formatter: value => `${value >= 10000 ? value / 10000 : value}${value ? 'w' : ''}` // ES6箭头函数
          }
        },
        visualMap: {
          type: 'piecewise',
          show: false,
          dimension: 0,
          seriesIndex: 0
        },
        series: [
          {
            type: 'line',
            smooth: 0.6,
            symbol: 'none',
            data: dataY,
            lineStyle: {
              color: '#B98236',
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(249, 173, 34, 0.3)' },
                { offset: 1, color: 'rgba(255, 219, 149, 0)' }
              ])
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#eee',
          borderWidth: 1,
          padding: [10, 15],
          textStyle: {
            color: '#333'
          }
        },
        grid: {
          top: 30,
          bottom: 60,
          left: 50,
          right: 30,
          containLabel: true
        }
      }
      myChart.setOption(option)
    }

    const renderPieCharts = (data, sectorAllAmt) => {
      const myChart = echarts.init(document.getElementById('pieCharts'))
      myChart.resize({
        height: 280
      })
      const option = {
        title: {
          text: i18n.global.t('pages_main_045'),
          textStyle: {
            fontSize: 14,
            color: '#333'
          },
          left: '47.5%',
          top: '38%',
          subtext: `$${sectorAllAmt}`,
          subtextStyle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000'
          },
          textAlign: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return i18n.global.t('pages_main_045') + '<br />' + params.data.name + ':' +
              `<span style="margin-left: 12px; font-weight: 600">${params.data.sourceValue}</span>`
          }
        },
        legend: {
          right: 0,
          top: 'bottom',
          // orient: 'vertical',
          // y: 'center',
          x: 'center',
          itemGap: 20,
          itemWidth: 20,
          itemHeight: 7,
          // icon: 'circle',
          itemStyle: {
            borderWidth: 0
          },
          // formatter: function (name) {
          //   let total = 0
          //   let target
          //   for (let i = 0; i < data.length; i++) {
          //     total += data[i].value
          //     if (data[i].name === name) {
          //       target = data[i].value
          //     }
          //   }
          //   var arr = [
          //     `{a|${name}}`,
          //     `{c|${((target / total) * 100).toFixed(2)}%}`
          //   ]
          //   return arr.join('')
          // },
          textStyle: {
            rich: {
              c: { color: '#c1c1c1', padding: [0, 0, 0, 12] }
            }
          }
        },
        color: ['#BA8438', '#FFDB95', '#FFEECC', '#F4F0EB', '#FFDB95', '#4065E0'],
        series: [
          {
            name: i18n.global.t('pages_main_045'),
            type: 'pie',
            radius: ['50%', '67%'],
            center: ['50%', '50%'],
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data
          }
        ]
      }
      myChart.setOption(option)
    }

    const dateClick = (scope) => {
      state.searchQuery.scope = scope
      loadAmountRatio()
    }

    const loadAmountRatio = async () => {
      state.chartsLoading = true
      state.isLine = false
      state.isPie = false
      const res = await _home.getAmountRatio(state.searchQuery)
      if (res.data.succ) {
        const { xaxis, yaxis, sectorData, sectorAllAmt } = res.data.data
        state.isLine = xaxis && yaxis
        state.isPie = yaxis
        nextTick(() => {
          renderLineCharts(xaxis || [], yaxis || [])
          renderPieCharts(sectorData || [], parseMoney(sectorAllAmt))
        })
      }
      state.chartsLoading = false
    }

    return {
      dateClick,
      loadAmountRatio,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#areaEcharts {
  background: #F7F8FA;
  margin-top: 18px;
  border-radius: 8px;

  // padding: 24px;
  .search-tab {
    display: flex;

    .date-select {
      margin-left: auto;
    }
  }

  .charts-area {
    display: flex;
    margin-top: 18px;
    position: relative;
    justify-content: space-between;

    .line-charts {
      background: #fff;
      width: 75%;
      border-radius: 20px;
      height: 400px;
      margin-right: 20px;
      position: relative;

      .charts-title,
      .pie-title {
        position: absolute;
        left: 0;
        font-size: 18px;
        font-weight: 600;
        padding: 10px 20px 10px 20px;
      }
    }

    .pie-charts {
      background: #fff;
      width: 24%;
      border-radius: 20px;
      height: 400px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .flex-align {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    #lineCharts,
    #pieCharts,
    #lineEmpty,
    #pieEmpty,
    #lineLoading,
    #pieLoading {
      flex: 1;
      height: 400px;
      justify-content: center;
    }

    #lineCharts,
    #lineEmpty,
    #lineLoading {
      flex: 1.5;
      // .ant-spin-spinning{
      //   position: absolute;
      //   right: 150px;
      // }
    }
  }
}

@media (max-width: 768px) {
  #register {
    font-size: 16px;

    .register-swiper {
      display: none;
    }

    .register-body {
      .card-register {
        padding: 25px;

        .card-body {
          margin: 10px 0 0 10px;
        }

        margin-left: 10%;
        margin-right: 10%;

        .ant-form-item {
          margin: 0 0 10px;
        }
      }
    }

    .layout-header {
      top: 10px;
      right: 10px;
    }
  }
}
</style>
